import type { FunctionComponent } from "react";

import type { Props as BaseEntityLinkProps } from "shared/components/common/base-entity-link";
import type { LinkEntity } from "shared/components/common/base-entity-link/types";
import { application } from "shared/data";
import { notEmpty } from "shared/lib/utils";

import LogoEPaper from "./logo-e-paper.svg";
import LogoGoodSchoolsGuide from "./logo-good-schools-guide.svg";
import LogoMobileEdition from "./logo-mobile-edition.svg";
import LogoPosties from "./logo-posties.svg";
import LogoRacing from "./logo-racing.svg";
import LogoScmpLive from "./logo-scmp-live.svg";
import LogoScmpPlus from "./logo-scmp-plus.svg";
import LogoYoungPost from "./logo-young-post.svg";
import { Container, StyledBaseEntityLink } from "./styles";

const scmpOneLineMenuAllUTMSource = "scmp_oneline_menu_all";

const mobileEditionLinkEntity: LinkEntity = {
  applicationId: "others",
  entityId: "",
  urlAlias: "https://app.scmp.com",
};

const paperLinkEntity: LinkEntity = {
  applicationId: "others",
  entityId: "",
  urlAlias: "/epaper",
};

const racingLinkEntity: LinkEntity = {
  applicationId: "others",
  entityId: "",
  urlAlias: "https://www.scmp.com/sport/racing",
};

const goodSchoolsGuideLinkEntity: LinkEntity = {
  applicationId: "others",
  entityId: "",
  urlAlias: "https://goodschoolsguide.scmp.com/",
};

const logoList = [
  {
    component: LogoMobileEdition,
    linkEntity: mobileEditionLinkEntity,
  },
  {
    component: LogoEPaper,
    linkEntity: paperLinkEntity,
  },
  {
    component: LogoScmpPlus,
    linkEntity: application.scmpPlus,
  },
  {
    component: LogoYoungPost,
    customizedQueryParameters: {
      utm_source: scmpOneLineMenuAllUTMSource,
    },
    linkEntity: application.yp,
  },
  {
    component: LogoPosties,
    customizedQueryParameters: {
      utm_source: scmpOneLineMenuAllUTMSource,
    },
    linkEntity: application.posties,
  },
  {
    component: LogoRacing,
    linkEntity: racingLinkEntity,
  },
  {
    component: LogoGoodSchoolsGuide,
    linkEntity: goodSchoolsGuideLinkEntity,
  },
  {
    component: LogoScmpLive,
    customizedQueryParameters: {
      utm_source: scmpOneLineMenuAllUTMSource,
    },
    linkEntity: application.scmpLive,
  },
];

export type Props = {
  className?: string;
  queryParameter: BaseEntityLinkProps["query"];
};

export const HeaderAllMenuApplications: FunctionComponent<Props> = ({
  className,
  queryParameter,
}) => (
  <Container className={className}>
    {logoList.map((logo, index) => (
      <StyledBaseEntityLink
        key={index}
        linkEntity={logo.linkEntity}
        query={
          notEmpty(logo.customizedQueryParameters) ? logo.customizedQueryParameters : queryParameter
        }
      >
        <logo.component />
      </StyledBaseEntityLink>
    ))}
  </Container>
);

HeaderAllMenuApplications.displayName = "HeaderAllMenuApplications";
